import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

// Per-environment Entra app registration (ALIS / ALIS-QA / ALIS-Dev), injected at build time by the
// deploy workflow. Local dev falls back to ALIS-Dev, which registers the localhost redirect URIs.
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || 'e558dfea-be0c-465a-82f2-66f440f6adcc';
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || '13b20fb1-7751-4ce4-ab35-5178f6ec731b';

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage' as const,
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (_level: LogLevel, message: string) => {
        console.debug(message);
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before use — required in v5+
export const msalReady = msalInstance.initialize();

export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account' as const,
};

/** Scopes for searching the organization directory (GAL) */
export const galRequest = {
  scopes: ['User.ReadBasic.All'],
};

export const graphConfig = {
  photoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
  usersEndpoint: 'https://graph.microsoft.com/v1.0/users',
};
